/** How many placeholder rows a table's skeleton shows while it loads. */
export const TABLE_PLACEHOLDER_ROW_COUNT = 5
